import React, { useState, useRef } from 'react';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable'; // Import the plugin for jsPDF
import IconButton from '../../elements/IconButton';
import Button from '../../elements/Button';

const Main = (props) => {
    const [loadedData, setLoadedData] = useState([]);
    const [stillGettingData, setStillGettingData] = useState(0);
    const isCancelled = useRef(false); // Used to track if fetching was cancelled

    const handleCancelFetch = () => {
        isCancelled.current = true; // Set flag to true when fetching is cancelled
    };

    const fetchAllData = (exportType) => {
        let skip = 0;
        const limit = 15;
        let allData = [];
        setStillGettingData(1);

        const fetchNext = () => {
            if (isCancelled.current) {
                console.log("Fetching has been cancelled by the user.");
                setStillGettingData(0); // Update state to reflect cancellation
                return;
            }
            getData(skip, limit, (hasMoreData, newData) => {
                if (false) {
                    allData = allData.concat(newData);
                    skip += limit;
                    fetchNext();
                } else {
                    allData = allData.concat(newData);
                    if (exportType === 'CSV') {
                        downloadCSV(allData, props.exportKeys, props.fileTitle);
                    } else if (exportType === 'PDF') {
                        downloadPDF(allData, props.exportKeys, props.fileTitle);
                    }
                    setStillGettingData(2);
                }
            });
        };

        fetchNext();
    };

    const getData = (skip, limit, onCompletion) => {
        var myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", "Bearer " + localStorage.getItem('access_token'));
        myHeaders.append("Content-Type", "application/json");

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify(props.filterData)
        };

        props.tokenSafeAPIRequest(
            `${props.url}${props.specific ? '/' + props.specific : ''}?limit=${limit}&fetch_links=true&skip=${skip}&sort_field=${props.sort}&start_date=${props.calStartDate}&end_date=${props.calEndDate}&active_only=false`,
            requestOptions,
            '',
            (result, status) => {
                if ('postProcessing' in props) {
                    result = props.postProcessing(result);
                }

                console.log(result)

                if ('reports' in result) {
                    processResult(result.reports, onCompletion);
                } else if ('accounts' in result) {
                    processResult(result.accounts, onCompletion);
                } else if ('transactions' in result) {
                    processResult(result.transactions, onCompletion);
                } else if ('dealerships' in result) {
                    processResult(result.dealerships, onCompletion);
                } else if ('spiffs' in result) {
                    processResult(result.spiffs, onCompletion);
                } else if ('dppps_and_gap' in result) {
                    processResult(result.dppps_and_gap, onCompletion);
                } else if ('agents' in result) {
                    processResult(result, onCompletion);
                } else {
                    processResult(result, onCompletion);
                }
            }
        );
    };

    const processResult = (data, onCompletion) => {
        if (data.agents && data.agents.length > 0) {
            setLoadedData((loadedData) => [...loadedData, ...data.agents]);
            onCompletion(true, data);
        } else {
            onCompletion(false);
        }
    };

    const downloadCSV = (data, keys, filename = 'data.csv') => {
        console.log(keys)
        console.log(data)
        let dataAgents = data
        // Remove specific agents and capture McCready's net for CSV export
        let mccreadyNet = 0;
        const flattenObject = (obj, parentKey = '', res = {}) => {
            for (let key in obj) {
                let propName = parentKey ? parentKey + '.' + key : key;
                if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key])) {
                    flattenObject(obj[key], propName, res);
                } else {
                    res[propName] = obj[key];
                }
            }
            return res;
        };
    
        // Properly handle commas by enclosing values in double quotes
        // First, extract agents array and filter out the two specific user IDs
        let agentsArray = [];
        if (data && Array.isArray(data) && data[0] && Array.isArray(data[0].agents)) {
            agentsArray = data[0].agents.filter(agent => {
                const id = agent.user_ID || agent.userId || agent._id || agent.id || '';
                if (String(id) === '659742d17c605a59716c4561') {
                    const netVal = Number(agent.net);
                    if (Number.isFinite(netVal)) mccreadyNet += netVal;
                    return false;
                }
                if (String(id) === '659742d47c605a59716c4579') {
                    return false;
                }
                return true;
            });
        }

        dataAgents = agentsArray.map(item => {
            const flatItem = flattenObject(item);
            for (let key in flatItem) {
                if (typeof flatItem[key] === 'string') {
                    flatItem[key] = `${flatItem[key].replace(/"/g, '"')}`; // Escape double quotes and wrap in quotes
                }
            }
            return flatItem;
        });
    
        let csvContent = keys.map(key => key.label).join(',') + '\n';

        const formatMoney = (value) => {
            const num = Number(value);
            if (!Number.isFinite(num)) return "$0.00";
            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(num);
        };

        const formatNumber = (value) => {
            const num = Number(value);
            if (!Number.isFinite(num)) return '0.00';
            return new Intl.NumberFormat('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(num);
        };

        let totalNet = 0;
        let totalCC = 0;
        let totalMonthlyCC = 0;
        dataAgents.forEach(item => {
            totalNet = totalNet + item.net;
            totalCC = totalCC + item.contract_count;
            totalMonthlyCC = totalMonthlyCC + item.monthly_cc;
            const row = keys.map((key, colIndex) => {
                let raw = item[key.id];
                let value = (raw !== undefined && raw !== null) ? raw : '';

                if (colIndex === 1 || colIndex === 2) {
                    value = formatMoney(value);
                } else if (colIndex === 3) {
                    value = formatNumber(value);
                }

                value = `${value}`;
                return `"${value.replace(/"/g, '""')}"`;
            }).join(',');
            csvContent += row + '\n';
        });

        csvContent += 'Total,' + data[0].total_net + ',' + totalCC + '\n'
        csvContent += '@1 1/2%,' + (data[0].mccready_one_point_five_pct) + '\n'
        csvContent += '50%,' + (data[0].mccready_fifty_pct_net) + '\n'
        csvContent += 'MIN. 1100,' + 1100 + '\n'
    
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        if (navigator.msSaveBlob) {
            navigator.msSaveBlob(blob, filename);
        } else {
            const link = document.createElement('a');
            if (link.download !== undefined) {
                const url = URL.createObjectURL(blob);
                link.setAttribute('href', url);
                link.setAttribute('download', filename);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    };
    

    const downloadPDF = (data, keys, filename = 'data.pdf') => {
        const doc = new jsPDF({orientation: 'landscape'});

        //659742d17c605a59716c4561 - Dave Mccready ID
        //659742d47c605a59716c4579 - Geoff Frey ID

        data = data[0]
        console.log(data)
        console.log(keys)
    
        // Extract and remove specific agents:
        // - If agent.user_ID === '659742d17c605a59716c4561' (McCready), remove and store their `net` in `mccreadyNet`.
        // - If agent.user_ID === '659742d47c605a59716c4579', just remove them.
        let mccreadyNet = 0;
        if (data && Array.isArray(data.agents)) {
            data.agents = data.agents.filter(agent => {
                const id = agent.user_ID || agent.userId || agent._id || agent.id || '';
                if (String(id) === '659742d17c605a59716c4561') {
                    const netVal = Number(agent.net);
                    if (Number.isFinite(netVal)) mccreadyNet += netVal;
                    return false;
                }
                if (String(id) === '659742d47c605a59716c4579') {
                    return false;
                }
                return true;
            });
        }
        console.log('mccreadyNet', mccreadyNet)
    
        // Add title
        doc.text(props.fileTitle || 'Report', 20, 10);

        let pageCount = 1;

        const addPageNumbers = (doc) => {
            const pageSize = doc.internal.pageSize;
            const pageHeight = pageSize.height;
            const pageWidth = pageSize.width;
    
            // Add footer with page number
            const pageCount = doc.internal.getNumberOfPages();
            for (let i = 1; i <= pageCount; i++) {
                doc.setPage(i);
                doc.text(
                    `Page ${i}`,
                    pageWidth - 30,
                    pageHeight - 10
                );
            }
        };

        const formatMoney = (value) => {
            const num = Number(value);
            if (!Number.isFinite(num)) return "$0.00";

            return new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(num);
        };
    
        // Helper function to flatten nested objects (same as used in CSV)
        const flattenObject = (obj, parentKey = '', res = {}) => {
            for (let key in obj) {
                let propName = parentKey ? parentKey + '.' + key : key;
                if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key])) {
                    flattenObject(obj[key], propName, res);
                } else {
                    res[propName] = obj[key];
                }
            }
            return res;
        };
    
        // Flatten the data before adding to the table
        const flattenedData = data.agents.map(item => flattenObject(item));

        console.log(flattenedData)

        function formatNumber(value) {
            try {
                // Attempt to convert the input to a number
                const num = parseFloat(value);
                // Check if the conversion resulted in a valid number
                if (!isNaN(num)) {
                // Use Intl.NumberFormat for US-style number formatting with two decimal places
                return new Intl.NumberFormat('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }).format(num);
                } else {
                // Return a default value if the input is not a valid number
                return '0.00';
                }
            } catch (e) {
                // In case of any unexpected errors, return a default value
                return '0.00';
            }
        }
    
        // Prepare table data for PDF (headers and rows)
        let totalNet = 0;
        let totalCC = 0;
        let totalMonthlyCC = 0;

        flattenedData.map((item, index) => {
            totalNet = totalNet + item.net;
            totalCC = totalCC + item.contract_count;
            totalMonthlyCC = totalMonthlyCC + item.monthly_cc;
        })

        const rows = flattenedData.map((item, index) =>
            keys.map((key, index) => {
            const value = item[key.id] || "";
            if (index === 1 || index === 2) return formatMoney(value);
            if (index === 3) return formatNumber(value)
            return value
            })
        );
        const headers = keys.map(key => key.label);

        console.log(rows)

        rows.push(['Total', formatMoney(data.total_net), formatNumber(totalCC), ''])
        rows.push(['@1 1/2%', formatMoney(data.mccready_one_point_five_pct), '', ''])
        rows.push(['50%', formatMoney(data.mccready_fifty_pct_net), '', ''])
        rows.push(['MIN. $1,100', formatMoney(1100), '', ''])
    
        // Add the table using autoTable
        doc.autoTable({
            head: [headers],
            body: rows,
        });

        addPageNumbers(doc);
    
        // Save the PDF
        doc.save(filename);
    };
    

    return (
        <div style={{ width: '360px', height: 'auto', display: 'flex', flexDirection: 'column' }}>
            <div style={{ flexBasis: '10%', display: 'flex', flexDirection: 'row' }}>
                <span style={{ fontWeight: '500', fontSize: '20px', flexBasis: '99%' }}>Export Report</span>
                <IconButton img={false} colors={props.colors} Style={{ borderRadius: '3px', backgroundColor: props.colors.border, width: '24px' }} size="16px">
                    <div onClick={() => { handleCancelFetch(); props.setIsOpen() }} style={{ paddingLeft: '3px', paddingRight: '3px' }}><span onClick={() => { handleCancelFetch(); props.setIsOpen() }}>x</span></div>
                </IconButton>
            </div>
            <div style={{ flexBasis: '90%', display: 'flex', flexDirection: 'column', marginTop: '20px' }}>
                <span style={{ fontWeight: '500', fontSize: '16px' }}>Downloaded Rows: {loadedData.length}</span>
                <Button colors={props.colors} active={true} Style={{ marginTop: '10px' }} onClick={() => fetchAllData('CSV')}>Download CSV</Button>
                <Button colors={props.colors} active={true} Style={{ marginTop: '10px' }} onClick={() => fetchAllData('PDF')}>Download PDF</Button>
            </div>
        </div>
    );
};

export default Main;
